export function phoneValidator(num: string) {

	// const numWithoutDot = num.replace('(', '').replace(')', '')

	// const tester = new RegExp(
	// 	/^(?:(?:\+|00)?(55)\s?)?(?:\(?([1-9][0-9])\)?\s?)?(?:((?:9\d|[2-9])\d{3})-?(\d{4}))$/,
	// 	'gm'
	// )

	// if (tester.test(numWithoutDot)) {
	// 	return true
	// }

	// return false

	// Provisório Atualizar Campo DDD Pais. 
	const digitsOnly = num.replace(/\D/g, '');

    if (digitsOnly.length > 10) {
        return true;
    } else {
        return false;
    }
}
